export default "__VITE_ASSET__BKqboJsL__"